<template>
  <div class="place-details">
    <div class="top-bar">
      <svg
        @click="$emit('done')"
        class="back-btn"
        id="gml:icon1/shell-breadcrumb"
        viewBox="0 0 24 24"
      >
        <path
          d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"
        ></path>
      </svg>
      <span>Place Details</span>
      <svg
        @click="$emit('done')"
        class="x-btn"
        id="gml:icon1/dialog-close"
        viewBox="0 0 24 24"
      >
        <path
          d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
        ></path>
      </svg>
    </div>
    <div class="info-grid-1">
      <svg
        v-if="placeId === 0"
        class="place-type-icon"
        width="50"
        height="55"
        viewBox="0 0 72 80"
      >
        <g fill="none" fill-rule="evenodd">
          <g>
            <path
              fill="#486F76"
              d="M36.5 3C22.475 3 11 14.028 11 27.6c0 5.373 1.842 10.463 5.1 14.704l19.267 25.167c.425.565 1.416.707 1.983.282l.283-.282L56.9 42.304c3.258-4.241 5.1-9.33 5.1-14.703C62 14.028 50.525 3 36.5 3z"
            ></path>
            <g fill="#FFF" transform="translate(20, 14) scale(1.4, 1.4)">
              $
              <path
                transform="translate(-14, -13) scale(2.2, 2.2)"
                d="M10.53 7.836a.35.35 0 0 0-.35.35v1.021c-.57.073-1.093.18-1.543.312-.46.136-.845.295-1.141.498-.296.204-.537.48-.537.842 0 .09.018.176.045.256l.558 3.054v.004c.093.467.474.762.868.97.395.209.84.336 1.222.396 1.598.25 2.559.307 4.198.054.38-.058.89-.189 1.353-.401.463-.212.928-.496 1.03-1.021l-.001.015.724-2.964a.826.826 0 0 0 .085-.363c0-.349-.223-.63-.504-.836-.281-.206-.649-.368-1.089-.504a9.529 9.529 0 0 0-1.67-.334v-1a.35.35 0 0 0-.35-.349.35.35 0 0 0-.35.35v.936a15.245 15.245 0 0 0-2.197.013v-.95a.35.35 0 0 0-.35-.349Zm1.552 1.952c1.25 0 2.376.159 3.16.401.392.121.697.265.88.4.183.134.218.226.218.27 0 .044-.035.138-.218.272-.04.03-.089.06-.141.09l-.012-.005c-.975-.422-2.391-.672-3.982-.672-1.576 0-2.981.246-3.956.662a1.794 1.794 0 0 1-.137-.083c-.2-.137-.234-.232-.234-.264s.035-.128.234-.265c.199-.136.527-.283.942-.405.828-.244 1.996-.401 3.246-.401Zm-.095 1.457c1.133 0 2.175.14 2.979.363-.762.197-1.773.322-2.884.322-1.136 0-2.202-.13-3.01-.338.795-.213 1.812-.347 2.915-.347zm-4.128.66c.228.11.486.21.778.295.919.27 2.137.43 3.445.43 1.308 0 2.486-.16 3.366-.432.22-.068.422-.143.604-.226l-.502 2.056-.002.01c-.02.107-.256.342-.636.517-.381.175-.856.297-1.168.346l-.045.005V14.6c0-.514-.46-.887-.967-.887h-1.515c-.505 0-.969.373-.969.887v.323a34.764 34.764 0 0 1-.488-.074 3.47 3.47 0 0 1-1.006-.324c-.302-.16-.478-.356-.505-.49Zm3.358 2.507h1.515c.177 0 .267.108.267.187v.398c-.75.08-1.356.08-2.05.01v-.408c0-.08.092-.187.268-.187z"
              ></path>
            </g>
          </g>
        </g>
      </svg>
      <svg
        v-else-if="placeId === 1"
        class="place-type-icon"
        width="50"
        height="55"
        viewBox="0 0 72 80"
      >
        <g fill="none" fill-rule="evenodd">
          <g>
            <path
              fill="#486F76"
              d="M36.5 3C22.475 3 11 14.028 11 27.6c0 5.373 1.842 10.463 5.1 14.704l19.267 25.167c.425.565 1.416.707 1.983.282l.283-.282L56.9 42.304c3.258-4.241 5.1-9.33 5.1-14.703C62 14.028 50.525 3 36.5 3z"
            ></path>
            <g fill="#FFF" transform="translate(20, 14) scale(1.4, 1.4)">
              $
              <path
                d="M6.9 7.907v1.2H5.588l-1.252 11.6h15.326l-1.258-11.6H17.1v-1.2h2.381L20.88 20.8c.06.55-.337 1.043-.887 1.103l-.107.005H4.114c-.552 0-1-.447-1-1l.006-.107L4.512 7.907H6.9zM12 1.4c2.332 0 4.235 1.835 4.345 4.14l.005.21V12h-1.2V5.75c0-1.74-1.41-3.15-3.15-3.15-1.68 0-3.052 1.315-3.145 2.971l-.005.179V12h-1.2V5.75C7.65 3.348 9.598 1.4 12 1.4zm2.4 6.507v1.2H9.6v-1.2h4.8z"
              ></path>
            </g>
          </g>
        </g>
      </svg>
      <svg
        v-else-if="placeId === 2"
        class="place-type-icon"
        width="50"
        height="55"
        viewBox="0 0 72 80"
      >
        <g fill="none" fill-rule="evenodd">
          <g>
            <path
              fill="#486F76"
              d="M36.5 3C22.475 3 11 14.028 11 27.6c0 5.373 1.842 10.463 5.1 14.704l19.267 25.167c.425.565 1.416.707 1.983.282l.283-.282L56.9 42.304c3.258-4.241 5.1-9.33 5.1-14.703C62 14.028 50.525 3 36.5 3z"
            ></path>
            <g fill="#FFF" transform="translate(20, 14) scale(1.4, 1.4)">
              $
              <path
                transform="translate(-14, -13) scale(2.2, 2.2)"
                d="M12 14.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
              ></path>
            </g>
          </g>
        </g>
      </svg>
      <span class="name">{{ currentPlace.name }}</span>
      <span>{{ currentPlace.types[0].type }}</span>
      <span>{{ currentPlace.address }}</span>
    </div>
    <div class="tag-area">
      <template v-for="(typeObj, i) of currentPlace.types">
        <div
          class="bullet"
          :style="{ backgroundColor: typeObj.bulletColor }"
          :key="'a' + i"
        />
        <span :key="'b' + i">{{ typeObj.type }}</span>
      </template>
    </div>
    <div class="info-grid-2">
      <svg
        v-if="currentPlace.phone"
        id="gfs:icon1/map-info-phone"
        viewBox="0 0 24 24"
      >
        <g fill="none" fill-rule="evenodd">
          <circle fill="#D1D6E0" cx="12" cy="12" r="12"></circle>
          <path
            d="M8.25 4.5c.458 0 .833.375.833.833 0 1.042.167 2.042.475 2.975a.836.836 0 0 1-.136.77l-.072.08-2.187 2.162a12.619 12.619 0 0 0 5.199 5.337l.292.155 2.188-2.162a.854.854 0 0 1 .591-.242.7.7 0 0 1 .259.042 9.506 9.506 0 0 0 2.975.475c.425 0 .779.323.827.737l.006.096v2.909a.836.836 0 0 1-.833.833C10.842 19.5 4.5 13.158 4.5 5.333c0-.425.323-.779.737-.827l.096-.006H8.25zm7.227 10.928-2.024 2 .031.013a13.116 13.116 0 0 0 4.92 1.056h.096v-2.575l-.209-.004a10.518 10.518 0 0 1-2.602-.424l-.212-.066zM8.086 5.5H5.502v.096c.033 1.657.371 3.239.961 4.691l.094.225 2.019-1.995-.077-.247a10.46 10.46 0 0 1-.41-2.56l-.003-.21z"
            fill="#71798A"
          ></path>
        </g>
      </svg>
      <span v-if="currentPlace.phone">{{ currentPlace.phone }}</span>
      <svg
        v-if="currentPlace.email"
        id="gfs:icon1/map-info-email"
        viewBox="0 0 24 24"
      >
        <g fill="none" fill-rule="evenodd">
          <circle fill="#D1D6E0" cx="12" cy="12" r="12"></circle>
          <g transform="translate(2.000000, 2.000000)">
            <path
              d="M18,4.5 L18,13.332714 C18,14.529331 17.0299503,15.4993807 15.8333333,15.4993807 L15.8333333,15.4993807 L4.16666667,15.4993807 C2.97004971,15.4993807 2,14.529331 2,13.332714 L2,13.332714 L2,4.5 L18,4.5 Z M16.3875286,8.4763825 L16.2368205,8.549695 L10,11.371985 L3.76317952,8.549695 C3.48003025,8.42156412 3.22358022,8.25284286 2.99944473,8.05223573 L3,13.332714 C3,13.9391443 3.46269073,14.4375074 4.05430888,14.49404 L4.05430888,14.49404 L4.16666667,14.4993807 L15.8333333,14.4993807 C16.4776655,14.4993807 17,13.9770462 17,13.332714 L17,13.332714 L17.0012236,8.05163714 C16.8173814,8.2162799 16.6117826,8.35946419 16.3875286,8.4763825 Z M17,5.49916667 L3,5.49916667 L3,5.81651417 C3,6.55292376 3.40413166,7.225412 4.04431812,7.57343417 L4.17545301,7.638635 L10,10.2741667 L15.824547,7.638635 C16.4954604,7.33503284 16.9415242,6.68959534 16.9946614,5.96286667 L17,5.81651417 L17,5.49916667 Z"
              fill="#71798A"
            ></path>
          </g>
        </g>
      </svg>
      <span v-if="currentPlace.email">{{ currentPlace.email }}</span>
      <svg
        v-if="currentPlace.url"
        id="gfs:icon1/map-info-website"
        viewBox="0 0 24 24"
      >
        <g fill="none" fill-rule="evenodd">
          <circle fill="#D1D6E0" cx="12" cy="12" r="12"></circle>
          <path
            d="M12 3.667a8.333 8.333 0 1 1 0 16.666 8.333 8.333 0 0 1 0-16.666zM5.172 9.319l-.1-.22c.584 1.322 1.213 2.247 1.873 2.779.296.238.681.489 1.167.77l.312.175.965.524c.492.269.702.398.83.563l.036.051c.151.232.16.335.108.983l-.035.469c-.021.39.01.63.058.69l.282.34c.531.647.79 1.115.79 1.686 0 .349-.03.74-.09 1.175.208.02.419.03.632.03.215 0 .427-.01.637-.028l1.145-3.21a.5.5 0 0 1 .171-.231c.591-.444.857-.824.857-1.112 0-.468-.49-1.068-.902-1.142l-.082-.007h-2.304a.5.5 0 0 1-.301-.101l-.061-.055-.902-.948-.053-.012c-1.168-.289-1.77-.578-1.883-1.09l-.015-.086c-.085-.774.799-1.17 1.817-1.278.185-.02.346-.002.509.052l.131.05-.186-.318c-.125-.223-.172-.327-.172-.492 0-.386.28-.659.846-1.021a.5.5 0 0 1 .316-.077l.082.014.085.022-.022-.027a.943.943 0 0 1-.166-.7l.022-.12c.078-.339.251-.528.547-.7l.232-.122.033-.012-.009-.02c-.103-.195-.72-.842-1.767-1.727l-.035-.03a7.346 7.346 0 0 0-5.398 4.513zm-.397 1.419-.012.072a7.336 7.336 0 0 0 5.616 8.343c.053-.386.079-.728.079-1.024 0-.238-.14-.514-.452-.914l-.392-.477c-.242-.294-.308-.668-.292-1.212l.018-.325.045-.589a.434.434 0 0 1 .016-.104l.003-.004-.495-.28-.603-.326a28.883 28.883 0 0 1-.693-.384c-.527-.304-.952-.581-1.295-.857-.555-.447-1.067-1.087-1.543-1.92zM12 4.667l-.06.002c.986.888 1.448 1.479 1.448 1.94 0 .421-.179.642-.53.844l-.26.139c-.033.02-.045.03-.05.04l-.004.009c-.013.053-.022.042.18.092a.5.5 0 0 1 .306.744l-.045.063-.546.649a.5.5 0 0 1-.43.176l-.08-.015-.316-.083-.089.066-.049.04.263.449.05.088c.399.728.514 1.147.007 1.478a.765.765 0 0 1-.67.085l-.098-.036c-.077-.032-.093-.036-.166-.081l-.259-.167c-.198-.128-.298-.168-.373-.16a2.902 2.902 0 0 0-.634.141l-.105.042.075.032c.178.073.411.149.698.226l.37.092a.5.5 0 0 1 .194.094l.054.048.855.9h2.09c.976 0 1.906 1.04 1.98 2.026l.004.123c0 .625-.382 1.214-1.098 1.788l-.038.029-.909 2.55a7.342 7.342 0 0 0 5.464-5.881l-2.038-.466a.5.5 0 0 1-.288-.187l-.047-.075-.861-1.705a.5.5 0 0 1-.017-.414l.039-.077.996-1.596a.5.5 0 0 1 .118-.13l.074-.048.965-.506A7.328 7.328 0 0 0 12 4.667zm6.653 4.244-.864.453-.775 1.242.628 1.244 1.688.385a7.306 7.306 0 0 0-.677-3.324z"
            fill="#71798A"
          ></path>
        </g>
      </svg>
      <span v-if="currentPlace.url" class="url">
        <a :href="currentPlace.url" target="_blank">
          {{ currentPlace.url }}
        </a>
      </span>
    </div>
  </div>
</template>

<script>
import places from '../../json/places.json';

export default {
  props: {
    placeId: Number,
  },
  computed: {
    currentPlace() {
      return this.places[this.placeId];
    },
  },
  data() {
    return {
      places,
    };
  },
};
</script>

<style lang="scss" scoped>
.place-details {
  width: 260px;
  height: calc(100% - 131px);
  // max-height: 605px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin-left: 32px;
  margin-top: 32px;
  padding: 16px 48px;
  animation: slideMapDetail 0.5s ease;
  touch-action: none;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  position: relative;
}
.top-bar {
  width: calc(100% + 32px + 32px);
  height: 30px;
  display: grid;
  grid-template-columns: 30px auto 30px;
  margin: 0 -32px 24px -32px;
  align-items: center;
  color: rgb(26, 28, 30);
  font-weight: bold;
  font-size: 16px;
  .back-btn {
    width: 20px;
    fill: rgb(96, 97, 100);
    padding: 8px;
    margin-left: -4px;
    cursor: pointer;
  }
  .x-btn {
    width: 20px;
    fill: rgb(118, 119, 122);
    padding: 8px;
    margin-left: -4px;
    cursor: pointer;
  }
}
.info-grid-1 {
  display: grid;
  grid-template-rows: 25px 16px auto;
  grid-template-columns: 50px auto;
  gap: 0 8px;
  color: rgb(96, 97, 100);
  font-size: 12px;
  .place-type-icon {
    grid-row: 1 / -1;
    width: 100%;
    height: 100%;
    margin-top: -10px;
  }
  .name {
    color: rgb(26, 28, 30);
    font-weight: bold;
    font-size: 16px;
  }
}
.tag-area {
  padding: 10px 12px;
  margin: 16px 0;
  border-top: 1px solid rgba(0, 28, 56, 0.16);
  border-bottom: 1px solid rgba(0, 28, 56, 0.16);
  color: rgb(96, 97, 100);
  font-size: 12px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 8px 100px);
  white-space: nowrap;
  align-items: center;
  gap: 6px;
  .bullet {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: black;
  }
}
.info-grid-2 {
  display: grid;
  grid-template-rows: repeat(auto-fill, 24px);
  grid-template-columns: 24px auto;
  gap: 26px 32px;
  padding: 0 11px;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    align-self: center;
    color: rgb(96, 97, 100);
    &.url {
      color: rgb(0, 114, 200);
      cursor: pointer;
      a {
        color: inherit;
        text-decoration: inherit;
      }
    }
  }
}
</style>
